/**
 * Every model of a project, whatever pushed it — Speckle branches and models pushed from APS/Forma
 * alike.
 *
 * `apiModelNames` is the API's own model dimension (`BuildingProject.GetAllModelNames()`, surfaced
 * as `modelNames` on `GET api/BuildingProject/{id}`), which unions the Speckle branches with the
 * material branch names. That is the same list the dashboard endpoint builds the toolbar's global
 * Models selector from, so reading it here is what keeps the two from disagreeing about which
 * models exist (RTLCA-5291).
 *
 * It replaces the old union with `apsData.models`: `apsData` has been null on the wire since project
 * metadata moved to Hasura (documented on the API's `BuildingProjectDetailedResponse.ApsData`), so
 * that leg contributed nothing. Deriving Forma models from `Material.BranchName` instead also covers
 * a push that registered no APS model at all.
 *
 * `speckleBranchNames` is the fallback, for a response that predates the field: naming the Speckle
 * branches is worse than naming every model, but far better than naming none — an empty list leaves
 * "Create material" and the Excel upload with no target to offer.
 *
 * Sorted, so every surface offering a model list orders it the same way.
 */
export const resolveAllModelNames = (apiModelNames: string[] | null | undefined, speckleBranchNames: string[]): string[] =>
  apiModelNames?.length ? [...apiModelNames].sort() : speckleBranchNames;
